import React, { FC } from 'react'

import { AccordionInfo, IsaacTable } from 'components'
import { IIsaacLink } from 'shared/interfaces'
import AccordionGlobalTitle from 'components/AccordionInfo/AccordionGlobalTitle'

import styles from './GlobalIsaakLinks.module.scss'

const GlobalIsaakLinks: FC<{ isaakLinks: IIsaacLink[] }> = ({ isaakLinks }) => isaakLinks.length ? (
  <AccordionInfo
    list={[{
      title: <AccordionGlobalTitle title={'Global ISAAC Links'} />,
      id: 'global-isaak',
      content: <IsaacTable isaakLinks={isaakLinks} className={styles.container} />,
      expand: false
    }]}
  />
) : null

export default GlobalIsaakLinks
